import { IoMdCheckmark } from "react-icons/io";
import Button from "../Button/Button";
import EventsService from "../../services/EventsService";
import ModalComponent from "../Modal/ModalComponent";
import Select from "../Select/Select";
import TextAreaInput from "../TextAreaInput/TextAreaInput";
import { AlarmResults } from "../AlarmActions/AlarmActions";
import { useState } from "react";
import { useUserStore } from "../../contexts/userStore";
import { useTranslation } from "react-i18next";
import { getEventData } from "../../constants/events";

export function FinishBatchAlarms({ categories, onlyPresentEventNames = false, ...props }) {
   const [modalIsOpen, setModalIsOpen] = useState(false);
   const [alarmConfirmation, setAlarmConfirmation] = useState(false);
   const [alarmAction, setAlarmAction] = useState("");
   const [alarmResult, setAlarmResult] = useState("");
   const [alarmEventName, setAlarmEventName] = useState(-1);
   const { selectedCondominio } = useUserStore();
   const { t } = useTranslation();

   const handleConfirm = async (modalType) => {
      if (modalType === "finish") {
         const query = {
            unitId: selectedCondominio,
         }
         if (alarmEventName && alarmEventName != -1) {
            query.eventName = alarmEventName;
         }
         const response = await EventsService.finishBatchAlarms(query, {
            alarm_confirmation: alarmConfirmation != null ? alarmConfirmation === 'true' : null,
            alarm_action: alarmAction,
            alarm_result: alarmResult,
         });
         setModalIsOpen(false);
         setAlarmConfirmation(false);
         setAlarmAction("");
         setAlarmResult("");
      }
   };

   const handleCancel = (modalType) => {
      if (modalType === "finish") {
         setModalIsOpen(false);
         setAlarmConfirmation(false);
         setAlarmAction("");
         setAlarmResult("");
      }
   };

   function getPendings() {
      return categories
         ?.reduce((prev, category) => {
            return prev + ((!alarmEventName || alarmEventName == -1 || category.name === alarmEventName) ? category.pending : 0);
         }, 0);
   }

   const categoryNames = new Set();
   for (const category of categories) {
      categoryNames.add(category.name);
   }

   return (
      <>
         <Button
            className='w-full'
            label={props.label ?? t("common.finish")}
            icon={<IoMdCheckmark />}
            type="button"
            onClick={() => setModalIsOpen(true)}
         />
         <ModalComponent
            modalIsOpen={modalIsOpen}
            modalText={t("monitoring.batchAlarmFinish", { pendings: getPendings() })}
            handleConfirm={() => handleConfirm("finish")}
            handleCancel={() => handleCancel("finish")}
         >
            <div style={{ display: 'flex', gap: '14px', width: '420px', flexDirection: 'column', marginTop: '20px' }}>
               <Select
                  labelText={t("common.event")}
                  name="eventName"
                  id="eventName"
                  value={alarmEventName}
                  onChange={({ target }) =>
                     setAlarmEventName(target.value)
                  }
                  options={[
                     onlyPresentEventNames ? { value: Array.from(categoryNames)?.join(';'), text: t("common.all") } : { value: -1, text: t("common.all") },
                     ...(Array.from(categoryNames)).map(category => ({ value: category, text: t(getEventData(category)?.name || category) })),
                  ]}
               />
               <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '14px' }}>
                  <Select
                     labelText={t("common.confirmation")}
                     name="alarm_confirmation"
                     id="alarm_confirmation"
                     value={alarmConfirmation}
                     onChange={({ target }) =>
                        setAlarmConfirmation(target.value)
                     }
                     required={true}
                     options={[
                        { value: "true", text: t("monitoring.confirmedAlarm") },
                        { value: "false", text: t("monitoring.falseAlarm") },
                     ]}
                  />
                  <Select
                     labelText={t("common.result")}
                     name="alarm_result"
                     id="alarm_result"
                     value={alarmResult}
                     onChange={({ target }) => setAlarmResult(target.value)}
                     required={true}
                     options={AlarmResults.map(result => ({ value: result.value, text: t(result.text) }))}
                  />
               </div>
               <TextAreaInput
                  labelText={t("common.action")}
                  name="alarm_action"
                  id="alarm_action"
                  type={"textfield"}
                  value={alarmAction}
                  onChange={({ target }) => setAlarmAction(target.value)}
                  required={true}
               />
            </div>
         </ModalComponent>
      </>
   );
}